import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × VERMEER: Domestic calm and precision
// Window-lit cubes, quiet tones, orderly interiors
export function VasarelyVermeerMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Soft ambient light background */}
      <rect x="0" y="0" width="794" height="1123" fill={brand.deep} opacity="0.85" />

      {/* Window light effect */}
      <defs>
        <linearGradient id="vermeer-window" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor={brand.aqua} stopOpacity="0.4" />
          <stop offset="50%" stopColor={brand.paper} stopOpacity="0.15" />
          <stop offset="100%" stopColor={brand.deep} stopOpacity="0.05" />
        </linearGradient>
      </defs>

      <rect x="50" y="200" width="300" height="600" fill="url(#vermeer-window)" />

      <g transform="translate(397 540)">
        {/* Orderly interior grid */}
        {Array.from({ length: 15 }).map((_, i) =>
          Array.from({ length: 20 }).map((_, j) => {
            const x = (i - 7) * 40;
            const y = (j - 9.5) * 35;
            const lightDist = Math.abs(x + 200); // Distance from window
            const illumination = Math.max(0, 1 - lightDist / 400);
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 12}
                y={y - 12}
                width="24"
                height="24"
                fill={illumination > 0.3 ? brand.aqua : brand.violet}
                opacity={0.15 + illumination * 0.15}
              />
            );
          })
        )}

        {/* Calm geometric forms (furniture metaphor) */}
        <rect x="-180" y="-220" width="140" height="180" fill={brand.violet} opacity="0.25" />
        <rect x="-180" y="-220" width="140" height="180" fill="none" stroke={brand.aqua} strokeWidth="2" opacity="0.4" />
        
        <rect x="60" y="-180" width="120" height="140" fill={brand.aqua} opacity="0.2" />
        <rect x="60" y="-180" width="120" height="140" fill="none" stroke={brand.violet} strokeWidth="2" opacity="0.4" />

        {/* Window frame structure */}
        <rect x="-240" y="-240" width="160" height="480" fill="none" stroke={brand.aqua} strokeWidth="3" opacity="0.5" />
        <line x1="-240" y1="0" x2="-80" y2="0" stroke={brand.aqua} strokeWidth="2" opacity="0.5" />
        <line x1="-160" y1="-240" x2="-160" y2="240" stroke={brand.aqua} strokeWidth="2" opacity="0.5" />

        {/* Perspective lines (orderly interior space) */}
        {[-200, -100, 0, 100, 200].map((y) => (
          <line
            key={y}
            x1="-280"
            y1={y}
            x2="280"
            y2={y}
            stroke={brand.white}
            strokeWidth="0.5"
            opacity="0.2"
          />
        ))}

        {/* Vertical calm structure */}
        {[-160, -80, 0, 80, 160].map((x) => (
          <line
            key={x}
            x1={x}
            y1="-280"
            x2={x}
            y2="280"
            stroke={brand.white}
            strokeWidth="0.5"
            opacity="0.2"
          />
        ))}

        {/* Quiet optical nodes */}
        {Array.from({ length: 5 }).map((_, i) =>
          Array.from({ length: 7 }).map((_, j) => {
            const x = (i - 2) * 80;
            const y = (j - 3) * 80;
            return (
              <circle
                key={`${i}-${j}`}
                cx={x}
                cy={y}
                r="4"
                fill={brand.aqua}
                opacity="0.3"
              />
            );
          })
        )}

        {/* Serene central focus */}
        <circle cx="50" cy="0" r="60" fill="none" stroke={brand.amber} strokeWidth="2" opacity="0.4" />
        <circle cx="50" cy="0" r="40" fill={brand.amber} opacity="0.15" />
      </g>

      {/* Quiet precision note */}
      <text x="397" y="1020" textAnchor="middle" fontFamily="serif" fontSize="11" fill={brand.aqua} opacity="0.5">
        stille orde
      </text>
    </g>
  );
}
